<template>
  <div class="popup" id="popup">
    <div class="popup__content popup--animate">
      <div class="popup__header">
        <svg class="popup__icon">
          <use href="@/assets/sprite.svg#icon-palette"></use>
        </svg>
        <h1 class="heading-tertiary">{{ $t('popup.photo.imageColorPicker.title') }}</h1>
      </div>
      <div class='popup__form'>
        <div class='u-display-flex'>
          <form @submit.prevent="selectColor" class="form" id="selectColorForm">
            <canvas class='imageColorPicker__canvas' ref="canvas" height=280 width=280>
            </canvas>
          </form>
          <div ref='color' class='imageColorPicker__color-box'></div>
          <div class='imageColorPicker__color-value'>{{ hexColor }}</div>
        </div>
      </div>
      <div class="popup__footer">
        <button class="popup__link u-pointer" type="button" form="selectColorForm" @click='close'>{{ $t('popup.photo.imageColorPicker.cancelAction') }}</button>
        <button class="popup__link u-pointer" type="submit" form="selectColorForm">{{ $t('popup.photo.imageColorPicker.confirmAction') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { formMixin } from '@/components/Mixins/Form'
import { toastMixin } from '@/components/Mixins/Toast'

export default {
  data: function () {
    return {
      canvas: '',
      context: '',
      hexColor: '#ffffff',
      downloadedImg: ''
    }
  },
  props: {
    photo: {
      type: File
    }
  },
  mixins: [formMixin, toastMixin],
  mounted: function () {
    // console.log(this.photo)
    this.canvas = this.$refs.canvas
    this.context = this.canvas.getContext('2d')
    this.color = this.$refs.color
    this.startDownload()
  },
  methods: {
    close () {
      this.$emit('popup:close')
      this.$store.commit('photo/SHOW_IMAGE_COLORPICKER_POPUP', false)
    },
    async selectColor () {
      this.$emit('changeColor', this.hexColor)
      this.sendSuccessToast(this.$t('feedback-ok.photo.imagecolorpicker', { color: this.hexColor }))
      this.close()
    },
    startDownload () {
      this.downloadedImg = new Image()
      // this.downloadedImg.crossOrigin = 'Anonymous'
      this.downloadedImg.addEventListener('load', this.imageReceived, false)
      this.downloadedImg.src = URL.createObjectURL(this.photo)
    },
    imageReceived (e) {
      let { width: photoWidth, height: photoHeight } = this.downloadedImg
      let { width: canvasWidth, height: canvasHeight } = this.canvas

      let sizer = this.scalePreserveAspectRatio(photoWidth, photoHeight, canvasWidth, canvasHeight)
      this.context.drawImage(this.downloadedImg, 0, 0, photoWidth, photoHeight, 0, 0, photoWidth * sizer, photoHeight * sizer)

      this.canvas.addEventListener('click', this.imageInfos, false)
    },
    rgbToHex (r, g, b) {
      if (r > 255 || g > 255 || b > 255) throw new Error('Invalid color component')
      return ((r << 16) | (g << 8) | b).toString(16)
    },
    imageInfos (e) {
      // console.log(e)
      // let pos = this.getMousePos(e)
      let pixel = this.context.getImageData(e.offsetX, e.offsetY, 1, 1)
      let { data } = pixel

      this.color.style.background = 'rgba(' + data[0] + ', ' + data[1] + ', ' + data[2] + ', ' + (data[3] / 255) + ')'
      this.hexColor = '#' + ('000000' + this.rgbToHex(data[0], data[1], data[2])).slice(-6)
    },
    getMousePos (evt) {
      let rect = this.canvas.getBoundingClientRect()
      return {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top
      }
    },
    scalePreserveAspectRatio (imgW, imgH, maxW, maxH) {
      return (Math.min((maxW / imgW), (maxH / imgH)))
    }
  }
}
</script>
